const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

/** Formata um valor monetário (number ou string vinda da API) como moeda BRL. */
export function formatBRL(value: number | string | null | undefined): string {
  const n = typeof value === 'string' ? Number.parseFloat(value) : (value ?? 0)
  return BRL.format(Number.isFinite(n) ? n : 0)
}
